export default __webpack_public_path__ + "static/media/styled-component.6e34e546.svg";